import {
	FETCH_EMPLOYMENTS, FETCH_EMPLOYMENTS_SUCCESS, FETCH_EMPLOYMENTS_FAILURE, RESET_EMPLOYMENTS
} from '../actions/employments';

const INITIAL_STATE = {
    employmentsList: {employments: [], error:null, loading: false}
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {
        case FETCH_EMPLOYMENTS:// start fetching employments and set loading = true
            return { ...state, employmentsList: {employments:[], error: null, loading: true} };
        case FETCH_EMPLOYMENTS_SUCCESS:// return list of employments and make loading = false
            return { ...state, employmentsList: {employments: action.payload, error:null, loading: false} };
        case FETCH_EMPLOYMENTS_FAILURE:// return error and make loading = false
            error = action.payload || {message: action.payload.message};//2nd one is network or server down errors
            return { ...state, employmentsList: {employments: [], error: error, loading: false} };
        case RESET_EMPLOYMENTS:// reset employmentsList to initial state
            return { ...state, employmentsList: {employments: [], error:null, loading: false} };
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/reducer_employments.js
 **/